const cedulas = [
  {
    label: 'Con chip',
    value: 'ci-nueva',
    id: 'ci-nueva',
    image: require('../../assets/cedula-chip.png'),
  },
  {
    label: 'Sin chip',
    value: 'ci-vieja',
    id: 'ci-vieja',
    image: require('../../assets/cedula.png'),
  },
];

export default cedulas;
